<!-- {{diagnostic}} -->
<div *ngFor="let page of pages" class="ia-section bg1" id="{{page.slug}}">
	<section class="ia-section">
	<a routerLink="/{{page.slug}}">
	<div class="row section-content" >
		<div class="col-md-1 ia-select"></div>
		<div class="col-md-5 ia-image" [ngStyle]="{'background-size':'cover', 'background-repeat':'no-repeat','background-image':'url(\''+page.background_image+'\')'}"><h1><span>{{page.title}}</span></h1></div>
		<div class="col-md-6 ia-home-excerpt" [innerHTML]="page.excerpt"></div>
	</div>
	</a>
	</section>
</div>
